import { OptionType } from 'shared/components';

export function isOptionType(option: OptionType | null): option is OptionType {
  return option !== null;
}
